import { NotificationManager } from 'react-notifications';
import { cloneDeep } from 'lodash';
import { GlobalAuthFetch } from '../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch';
import i18n from '../../../../../Utils/i18next/i18next';
import { FetchMethodType } from '../../../../../Utils/GlobalVariables/Fetch/MethodsType';


export const onSubmit = async (values, props) => {
  const { updateTableRegistry, loadData, updateSingleRegistry, uuid } = props;
  const data = cloneDeep(values);

  data.parts = data.selectedParts;

  let payload;

  const res = await GlobalAuthFetch({
    path: `/service/${uuid}`,
    method: FetchMethodType.patch,
    data: data,
  });
  payload = res.payload;

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t('global:success'));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};

  if (!props.steps[0]?.error && props.isSubmit && Object.keys(errorsStep0).length > 0) {
    props.setErrorHeader(0, true);
  }
  if (!!props.steps[0]?.error && props.isSubmit && Object.keys(errorsStep0).length <= 0) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
